import axios from "axios"

export default {
  setCallback ({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/customer-requests/create-callback`, params.body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },

  setPopupModelAbout ({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/models/${params.id}/info`).then(res => {
        resolve(res.data);
        commit('updatePopupModelAbout', res.data);
      }, error => {
        reject(error)
      })
    })
  },

  setPersonalCalc ({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/orders/personal-calculation-request`, params.body).then(res => {
        resolve(res.data);
      }, error => {
        reject(error)
      })
    })
  },
}
